// @ts-nocheck
import {
    chain,
    PopulateApiParameter,
    SetExpandTokens,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";
import qs from "qs";

addToChainAfter(chain, SetExpandTokens, props => {
    props.expandTokens = props.expandTokens || [];
    props.expandTokens.push("properties");
});

addToChainAfter(chain, PopulateApiParameter, props => {
    const { queryString = "" } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString);

    const {
        excludeMultiLocationCatalogProducts: excludeMultiLocationCatalogProductsQs,
        onlyGreifProducts: onlyGreifProductsQs,
    } = parsedQuery;

    const includeMultiLocationCatalogProducts = excludeMultiLocationCatalogProductsQs !== "true";
    const onlyGreifProducts = onlyGreifProductsQs === "true" || undefined;

    props.apiParameter.additionalQueryStringParameters = {
        ...(props.apiParameter.additionalQueryStringParameters ?? {}),
        includeMultiLocationCatalogProducts,
        onlyGreifProducts,
    };

    // Just to be explicit, these need to be undefined (not false),
    // so that the query string parameters are not appended with the "false" value.
    props.result.productFilters.excludeMultiLocationCatalogProducts = includeMultiLocationCatalogProducts
        ? undefined
        : true;

    props.result.productFilters.onlyGreifProducts = onlyGreifProducts;
});
